import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';

const DateTime = ({ dateTime, format, returnStringOnly }) => {
  let dateTimeFormat;
  switch (format) {
    case 'short':
      dateTimeFormat = 'll';
      break;
    case 'long':
      dateTimeFormat = 'lll';
      break;
    default:
  }
  const renderDateTime = () => {
    let modifiedDateTime = dateTime;
    if (modifiedDateTime) {
      modifiedDateTime = moment(modifiedDateTime)
        .locale(I18n.locale)
        .format(dateTimeFormat);
    }
    return modifiedDateTime;
  };

  return returnStringOnly ? renderDateTime() : <span>{renderDateTime()}</span>;
};

DateTime.defaultProps = {
  returnStringOnly: false,
  dateTime: null,
  format: 'long',
};

DateTime.propTypes = {
  returnStringOnly: PropTypes.bool,
  dateTime: PropTypes.string,
  format: PropTypes.oneOf(['long', 'short']),
};

export default DateTime;
